module.exports = __webpack_public_path__ + "static/img/vipchart.bb534d40.png";